module.exports = __webpack_public_path__ + "img/stock0.da45a1d6.png";